<template>
  <nav class="mega-menu mega-menu--resources" data-gtm-context="Product Menu">
    <ul class="mega-menu__list">
      <li>
        <a class="mega-menu__item" href="/features/campaignbuilder/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"/><rect x="2" y="4" width="20" height="16" rx="2"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Campaign Builder</h6>
            <p class="mega-menu__description">Build emails that look great</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/signupforms/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h-1a2 2 0 0 1-2-2 2 2 0 0 1-2 2H6"/><path d="M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7"/><path d="M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1"/><path d="M6 4h1a2 2 0 0 1 2 2 2 2 0 0 1 2-2h1"/><path d="M9 6v12"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Signup Forms</h6>
            <p class="mega-menu__description">Collect sign-ups effortlessly</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/landing-pages/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M3 9h18"/><path d="M9 21V9"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Landing Pages</h6>
            <p class="mega-menu__description">Build pages that convert</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/conversations/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719"/><path d="M8 12h.01"/><path d="M12 12h.01"/><path d="M16 12h.01"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Conversations</h6>
            <p class="mega-menu__description">Handle replies from one inbox</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/sms/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="14" height="20" x="5" y="2" rx="2" ry="2"/><path d="M12 18h.01"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">SMS Campaigns</h6>
            <p class="mega-menu__description">Send messages people actually read</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/automations/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect width="8" height="8" x="3" y="3" rx="2"/><path d="M7 11v4a2 2 0 0 0 2 2h4"/><rect width="8" height="8" x="13" y="13" rx="2"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title"> Automations</h6>
            <p class="mega-menu__description">Set it up once, let it work</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/social-campaigns/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"/><path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"/><path d="M8 6v8"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Social Campaigns</h6>
            <p class="mega-menu__description">Manage all your socials together</p>
          </div>
        </a>
      </li>
      <li>
        <a class="mega-menu__item" href="/features/ai-content-assistant/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/><path d="M20 2v4"/><path d="M22 4h-4"/><circle cx="4" cy="20" r="2"/></svg>
          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">AI Content Assistant</h6>
            <p class="mega-menu__description">Get help writing your content</p>
          </div>
        </a>
      </li>
      <li class="mega-menu__list-item--separated">
        <a class="mega-menu__item" href="/features/">
          <div class="mega-menu__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-icon lucide-map"><path d="M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z"/><path d="M15 5.764v15"/><path d="M9 3.236v15"/></svg>          </div>
          <div class="mega-menu__content">
            <h6 class="mega-menu__title">Product Tour</h6>
            <p class="mega-menu__description">Everything you need to get started</p>
          </div>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "FeaturesMenu",
};
</script>
